<template>
  <div style="width: 100%;">
    <div>
      <div ref="textRef" class="leading-relaxed break-words" :id="idVal">
        <div v-if="!inversion">
          <template v-if="!asRawText">
            <div class="flex">
              <div  class="bg-#525252 h-32px px-10px mb-10px leading-32px rounded-8px cursor-pointer">{{ des || '已深度思考' }}</div>
            </div>
            <div
              v-if="reasoningVal && showReasoning"
              class="markdown-body"
              style="color:#a6a6a6;padding-left:13px;border-left:1px solid #ccc; margin-bottom:10px;"
              v-html="reasoningVal" />
							<markdown-it-vue class="md-body" v-if="text" :content="text" />
            <!-- <div v-if="textVal" class="markdown-body" :class="{ 'markdown-body-generate': loading }" v-html="textVal" /> -->
          </template>
					<markdown-it-vue v-else   :content="text" />
          <!-- <div v-else class="whitespace-pre-wrap" v-text="textVal" /> -->
        </div>
        <!-- <div v-else class="whitespace-pre-wrap" v-text="textVal" /> -->
				<markdown-it-vue class="md-body" v-else  :content="text" />
      </div>
    </div>
  </div>
</template>

<script>
import hljs from 'highlight.js'
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
export default {
	props:{
    text: {
			type: String,
			default: '',
		},
		reasoning: {
			type: String,
			default: '',
		},
		error: {
			type: Boolean,
			default: false,
		},
		inversion: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		asRawText: {
			type: Boolean,
			default: false,
		},
		idVal: {
			type: String,
			default: '',
		},
		tuiLi: {
			type: Boolean,
			default: false,
		},
		des: {
			type: String,
			default: "",
		},
  },
	data() {
    return {
			showReasoning:true,
			mdi:null,
    }
  },
	components: {
    MarkdownItVue
  },
	computed:{
		textVal () {
			// const value = this.text
			
			// if (!this.asRawText && this.mdi) {
				
			// 	// 对数学公式进行处理，自动添加 $$ 符号
			// 	const escapedText = this.escapeBrackets(this.escapeDollarNumber(value))
			// 	// console.log(escapedText,'valuevaluevalue')
			// 	try {
			// 		return this.mdi.render(escapedText)
			// 	} catch (e) {
			// 		console.error('Markdown渲染错误:', e)
			// 		return escapedText
			// 	}
			// }
			// return value
		},
		reasoningVal () {
			const value = this.reasoning ?? ''
			// if (!this.asRawText && this.mdi) {
			// 	// 对数学公式进行处理，自动添加 $$ 符号
			// 	const escapedText = this.escapeBrackets(this.escapeDollarNumber(value))
			// 	return this.mdi.render(escapedText)
			// }
			return value
		}
	},
	methods:{
		highlightBlock(str, lang) {
			return `<pre class="code-block-wrapper"><div class="code-block-header"><span class="code-block-header__lang">${lang}</span><span class="code-block-header__copy">复制代码</span><span class="code-block-header__view ${lang == 'html'?'ISHTMLT':''}" ${lang == 'html'?'display:none;':'style="display:none;"'}></span><span class="code-block-header__download ${lang == 'html'?'ISHTMLT':''}" ${lang == 'html'?'display:none;':'style="display:none;"'}></span></div><code class="hljs code-block-body ${lang}">${str}</code></pre>`
		},
		escapeBrackets(text) {
			const pattern = /(```[\s\S]*?```|`.*?`)|\\\[([\s\S]*?[^\\])\\\]|\\\((.*?)\\\)/g
			return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
				if (codeBlock) return codeBlock
				else if (squareBracket) return `$$${squareBracket}$$`
				else if (roundBracket) return `$${roundBracket}$`
				return match
			})
		},
		escapeDollarNumber(text) {
			let escapedText = ''
			for (let i = 0; i < text.length; i += 1) {
				let char = text[i]
				const nextChar = text[i + 1] || ' '
				if (char == '$' && nextChar >= '0' && nextChar <= '9') char = '\\$'
				escapedText += char
			}
			return escapedText
		}
	},
	async created () {
		await this.$nextTick();
		// const _this = this;
		// this.mdi = new MarkdownIt({
		// 	html: false,
		// 	linkify: true,
		// 	typographer: true,
		// 	breaks: true,
		// 	highlight(code, language) {
		// 		// console.log(code,language,'MarkdownItMarkdownIt')
		// 		const validLang = !!(language && hljs.getLanguage(language))
		// 		if (validLang) {
		// 			const lang = language ?? ''
		// 			return _this.highlightBlock(hljs.highlight(code, { language: lang }).value, lang)
		// 		}
		// 		return _this.highlightBlock(hljs.highlightAuto(code).value, '')
		// 	},
		// })
		// this.mdi.use(MdLinkAttributes, { attrs: { target: '_blank', rel: 'noopener' } }).use(MdKatex).use(MdMermaid);
		// console.log(this.mdi,'this.mdithis.mdi')
	},
}
</script>
<style lang="less">
.code-block-header__view{
  cursor: pointer;
  margin-left: 0.5rem;
  user-select: none;
}

.code-block-header__download{
  cursor: pointer;
  margin-left: 0.5rem;
  user-select: none;
}

.win-iframeDialog{
  .el-dialog.COMMON_VEADIALOG {
    width: 85%;
    height: 85%;
    margin: 0 !important;
  }
  .el-dialog__header{
    height: 46px;
    padding: 0;
    margin-right: 0;
  }
  .el-dialog__body{
    height: calc(100% - 46px) !important;
    width: 100%;
    padding: 0px 16px !important;
  }
}
</style>
